import { useI18N } from "common/hooks";
import { ImagesIcon, PlusCircleIcon } from "@phosphor-icons/react";
import { cn } from "@/lib/utils";

type NoVenuePhotosBannerProps = {
  /** Opens the contribution picker, which carries the get-the-app QR panel. */
  onAddPhotos: () => void;
  className?: string;
};

/**
 * Venue profile hero when a venue has no photos (Figma 14867:106993).
 *
 * The plate is #464649 in both themes, so contents carry `dark` — light-theme
 * `fg-neutral-strong` would be unreadable on it.
 */
export default function NoVenuePhotosBanner({
  onAddPhotos,
  className,
}: NoVenuePhotosBannerProps) {
  const i18n = useI18N();

  return (
    <div
      className={cn(
        "dark flex h-full w-full flex-col items-center justify-center gap-2 bg-container-neutral-subtle px-4 py-6",
        className,
      )}
    >
      <ImagesIcon
        size={32}
        aria-hidden="true"
        className="shrink-0 text-fg-neutral-strong"
      />
      <p className="title-s-semibold text-center text-fg-neutral-strong">
        {i18n.get("noPhotosYet")}
      </p>
      <button
        type="button"
        onClick={onAddPhotos}
        className="focus-blue flex min-h-6 items-center justify-center gap-1.5 rounded-lg"
      >
        <PlusCircleIcon
          size={20}
          aria-hidden="true"
          className="shrink-0 text-fg-brand-subtle"
        />
        <span className="label-m-medium text-fg-brand-subtle underline">
          {i18n.get("addPhotos")}
        </span>
      </button>
    </div>
  );
}
